/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  SET_FILTER_TYPE = "[History] Set filter type for history",
  SET_FILTER_DATE = "[History] Set filter date for history"
}

export const setFilterType = createAction(
  ActionTypes.SET_FILTER_TYPE,
  props<{data: any}>()
);

export const setFilterDate = createAction(
  ActionTypes.SET_FILTER_DATE,
  props<{ data: any }>()
);
